import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestAttachmentDelete = {
    path: "/attachments/:id",
    method: RouteHttpVerb.DELETE
};
export { locationRestAttachmentDelete };
